import { ChevronLeft, ChevronRight } from '@mui/icons-material';
import { Divider, IconButton, List, ListItem, ListItemButton, ListItemText, Tooltip, Typography } from '@mui/material';
import { action, makeObservable, observable } from 'mobx';
import { Observer, observer } from 'mobx-react';
import { default as React, ReactNode } from 'react';
import './css/transferList.css';

interface IPropsTransferList<T> {
    listToSelect: T[];
    listSelected?: T[];
    tituloListaParaSelecionar: string;
    tituloListaJaSelecionados: string;
    campoDeDescricao: string;
    labelTooltip: string;
    setListToSelect: boolean;
    callbackSelect: (listSelected: T[], listToSelect: T[]) => void;
    tooltipAcaoExtra?: string;
    acaoExtra?: (item: T) => void;
    iconeAcaoExtra?: ReactNode | ((item: T) => ReactNode);
    condicaoParaAcaoExtra?: (item: T) => boolean;
    ehIndicarJulgamento?: boolean
}


class TransferList<T = any> extends React.Component<IPropsTransferList<T>> {
    localListToSelect = [];
    localListSelected = [];


    organizarAlfabeticamente = (e1: T, e2: T): number => {
        return e1[this.props.campoDeDescricao].toLocaleLowerCase() > e2[this.props.campoDeDescricao].toLocaleLowerCase() ? 1 : -1;
    }

    constructor(props) {
        super(props);
        makeObservable(this, {
            localListToSelect: observable,
            localListSelected: observable,
            selecionar: action,
            retirar: action
        });
        this.localListToSelect = props.listToSelect ? props.listToSelect.slice() : [];
        this.localListSelected = props.listSelected ? props.listSelected.slice() : [];
    }

    componentDidUpdate(prevProps) {
        if (prevProps.listToSelect !== this.props.listToSelect) {
            this.localListToSelect = this.props.listToSelect ? this.props.listToSelect.slice() : [];
        }
        if (prevProps.listSelected !== this.props.listSelected) {
            this.localListSelected = this.props.listSelected ? this.props.listSelected.slice() : [];
        }
    }

    get listToSelect() {
        return this.localListToSelect.slice().sort(this.organizarAlfabeticamente)
            .filter(itemToSelect => !this.localListSelected.find(itemSelected => itemSelected[this.props.campoDeDescricao] === itemToSelect[this.props.campoDeDescricao]));
    }

    get listSelected() {
        return this.localListSelected.slice().sort(this.organizarAlfabeticamente);
    }

    selecionar = (item: T) => {
        const element = this.listToSelect.find(el => el[this.props.campoDeDescricao] === item[this.props.campoDeDescricao])
        const listSelected = this.listSelected.concat(element);
        this.localListSelected = listSelected;
        this.localListToSelect = this.listToSelect.filter(item => item[this.props.campoDeDescricao] !== element[this.props.campoDeDescricao]);
        this.props.callbackSelect(listSelected, this.localListToSelect);
    };

    retirar = (item: T) => {
        const element = this.listSelected.find(element => element[this.props.campoDeDescricao] === item[this.props.campoDeDescricao])
        const listToSelect = this.listToSelect.concat(element);
        const newListSelected = this.listSelected.filter(item => item[this.props.campoDeDescricao] !== element[this.props.campoDeDescricao]);
        this.localListSelected = newListSelected;
        this.localListToSelect = listToSelect;
        this.props.callbackSelect(newListSelected, listToSelect);
    };

    conferirClickDuplo = (item: T, funcao: (item: T) => void, ev: UIEvent): void => {
        if (ev.detail >= 2) {
            funcao(item);
        }
    }

    textosDoItem = (acao, item) => {
        const descricaoDoItem = item[this.props.campoDeDescricao];
        const labelTooltip = acao + ' ' +
            this.props.labelTooltip.slice(0, -1) +
            ' "' + descricaoDoItem + '"';
        return { labelTooltip, descricaoDoItem };
    }

    selecionarTodos = () => {
        this.props.callbackSelect(this.listToSelect.concat(this.listSelected), []);
    }

    retirarTodos = () => {
        this.props.callbackSelect([], this.listToSelect.concat(this.listSelected));
    }

    render() {
        const tituloListaParaSelecionar = this.props.tituloListaParaSelecionar;
        const tituloListaJaSelecionados = this.props.tituloListaJaSelecionados;
        const ehIndicarJulgamento = this.props.ehIndicarJulgamento;
        const acaoExtra = this.props.acaoExtra;
        const condicaoParaAcaoExtra = this.props.condicaoParaAcaoExtra;
        const iconeAcaoExtra = this.props.iconeAcaoExtra;
        const tooltipAcaoExtra = this.props.tooltipAcaoExtra;
        const campoDeDescricao = this.props.campoDeDescricao;
        const labelTooltip = this.props.labelTooltip;
        const organizarAlfabeticamente = (e1, e2) =>
            e1[campoDeDescricao].toLocaleLowerCase() > e2[campoDeDescricao].toLocaleLowerCase() ? 1 : -1;
        const textosDoItem = (acao, item) => {
            const descricaoDoItem = item[campoDeDescricao];
            const tooltipLabel = acao + ' ' + labelTooltip.slice(0, -1) + ' "' + descricaoDoItem + '"';
            return { labelTooltip: tooltipLabel, descricaoDoItem };
        };
        return (
            <Observer>
                {() => {
            const listToSelect = this.localListToSelect.slice().sort(organizarAlfabeticamente)
                .filter(itemToSelect => !this.localListSelected.find(itemSelected => itemSelected[campoDeDescricao] === itemToSelect[campoDeDescricao]));
            const listSelected = this.localListSelected.slice().sort(organizarAlfabeticamente);
            return (
            <div className='divTransferList'>
                <div className='divNaoAdicionadas gridTransferList'>
                    <Typography className='tituloList ' component={'span'}>
                        {tituloListaParaSelecionar} {'(' + listToSelect?.length + ')'}
                        <Tooltip title='Mover todos'>
                            <IconButton onClick={this.selecionarTodos.bind(this)} size='small' >
                                <ChevronRight />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                    <Divider />
                    <List className='listNaoAdd '>
                        {listToSelect.map((item, index) => {
                            if (ehIndicarJulgamento == true) {
                                const { labelTooltip, descricaoDoItem } = textosDoItem('Indicar pra presencial o', item);
                                return (
                                    <ListItem
                                        key={'naoadd' + index}
                                        disablePadding
                                        secondaryAction={
                                            <Tooltip title={labelTooltip}>
                                                <div>
                                                    <IconButton onClick={this.selecionar.bind(this, item)} edge='end'>
                                                        <ChevronRight />
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        }
                                    >
                                        <ListItemButton dense>
                                            <Tooltip title={labelTooltip}>
                                                <ListItemText onClick={this.conferirClickDuplo.bind(this, item, this.selecionar)}>
                                                    {descricaoDoItem}
                                                </ListItemText>
                                            </Tooltip>
                                        </ListItemButton>
                                    </ListItem>
                                );

                            } else {

                                const { labelTooltip, descricaoDoItem } = textosDoItem('Incluir', item);
                                return (
                                    <ListItem
                                        key={'naoadd' + index}
                                        disablePadding
                                        secondaryAction={
                                            <Tooltip title={labelTooltip}>
                                                <div>
                                                    <IconButton onClick={this.selecionar.bind(this, item)} edge='end'>
                                                        <ChevronRight />
                                                    </IconButton>
                                                </div>
                                            </Tooltip>
                                        }
                                    >
                                        <ListItemButton dense>
                                            <Tooltip title={labelTooltip}>
                                                <ListItemText onClick={this.conferirClickDuplo.bind(this, item, this.selecionar)}>
                                                    {descricaoDoItem}
                                                </ListItemText>
                                            </Tooltip>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            }

                        })}
                    </List>
                </div>
                <div className='divAdicionadas gridTransferList'>
                    <Typography className='tituloList ' component={'span'}>
                        {tituloListaJaSelecionados} {'(' + listSelected?.length + ')'}
                        <Tooltip title='Mover todos'>
                            <IconButton onClick={this.retirarTodos.bind(this)} size='small' >
                                <ChevronLeft />
                            </IconButton>
                        </Tooltip>
                    </Typography>
                    <Divider />
                    <List className='listAdd '>
                        {listSelected.map((item, index) => {
                            if (ehIndicarJulgamento == true) {
                                const { labelTooltip, descricaoDoItem } = textosDoItem('Indicar pra virtual o', item);

                                return (
                                    <ListItem
                                        key={'add' + index}
                                        disablePadding
                                        secondaryAction={acaoExtra && condicaoParaAcaoExtra?.call(this, item) ? (
                                            <>
                                                {typeof iconeAcaoExtra === 'function'
                                                    ? iconeAcaoExtra(item)
                                                    : iconeAcaoExtra ? (
                                                        <Tooltip title={tooltipAcaoExtra}>
                                                            <div>
                                                                <IconButton onClick={acaoExtra.bind(this, item)} edge='end' >
                                                                    {iconeAcaoExtra}
                                                                </IconButton>
                                                            </div>
                                                        </Tooltip>
                                                    ) : null
                                                }
                                            </>
                                        ) : undefined}
                                    >
                                        <ListItemButton dense style={{ maxHeight: '32px' }}>
                                            <Tooltip title={labelTooltip}>
                                                <IconButton onClick={this.retirar.bind(this, item)} size='small' >
                                                    <ChevronLeft />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={labelTooltip}>
                                                <ListItemText onClick={this.conferirClickDuplo.bind(this, item, this.retirar)} >
                                                    {descricaoDoItem}
                                                </ListItemText>
                                            </Tooltip>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            } else {
                                const { labelTooltip, descricaoDoItem } = textosDoItem('Remover', item);
                                return (
                                    <ListItem
                                        key={'add' + index}
                                        disablePadding
                                        secondaryAction={acaoExtra && condicaoParaAcaoExtra?.call(this, item) ? (
                                            <>
                                                {typeof iconeAcaoExtra === 'function'
                                                    ? iconeAcaoExtra(item)
                                                    : iconeAcaoExtra ? (
                                                        <Tooltip title={tooltipAcaoExtra}>
                                                            <div>
                                                                <IconButton onClick={acaoExtra.bind(this, item)} edge='end' >
                                                                    {iconeAcaoExtra}
                                                                </IconButton>
                                                            </div>
                                                        </Tooltip>
                                                    ) : null
                                                }
                                            </>
                                        ) : undefined}
                                    >
                                        <ListItemButton dense style={{ maxHeight: '32px' }}>
                                            <Tooltip title={labelTooltip}>
                                                <IconButton onClick={this.retirar.bind(this, item)} size='small' >
                                                    <ChevronLeft />
                                                </IconButton>
                                            </Tooltip>
                                            <Tooltip title={labelTooltip}>
                                                <ListItemText onClick={this.conferirClickDuplo.bind(this, item, this.retirar)} >
                                                    {descricaoDoItem}
                                                </ListItemText>
                                            </Tooltip>
                                        </ListItemButton>
                                    </ListItem>
                                );
                            }
                        })}
                    </List>
                </div>
            </div>
                );
                }}
            </Observer>
        );
    }
}

export default observer(TransferList);
